import { supabase } from "../supabase";
import { FEEDBACK_BUCKET } from "./feedbackSubmission";

const INBOX_COLUMNS = [
  "feedback_id",
  "feedback_type",
  "message",
  "attachment_path",
  "contact_allowed",
  "contact_email",
  "source_route",
  "source_screen",
  "created_at",
  "review_status",
  "resolved_at",
].join(", ");

const REVIEW_STATUSES = new Set(["new", "resolved"]);
const CONTACT_EMAIL = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
export const FEEDBACK_REPLY_SUBJECT = "CrewPilot Feedback Follow-up";

export function feedbackReviewStatus(value) {
  return value === "resolved" ? "resolved" : "new";
}

export function feedbackReplyHref(row) {
  if (!row?.contact_allowed) return null;
  const email = String(row.contact_email || "").trim();
  if (!CONTACT_EMAIL.test(email)) return null;
  return {
    email,
    href: `mailto:${email}?subject=${encodeURIComponent(FEEDBACK_REPLY_SUBJECT)}`,
  };
}

export async function loadFeedbackInbox(client = supabase, reviewStatus = "new") {
  const status = feedbackReviewStatus(reviewStatus);
  const { data, error } = await client
    .from("feedback")
    .select(INBOX_COLUMNS)
    .eq("review_status", status)
    .order("created_at", { ascending: false })
    .limit(100);

  if (error) {
    throw error;
  }
  return data || [];
}

export async function countNewFeedback(client = supabase) {
  const { count, error } = await client
    .from("feedback")
    .select("feedback_id", { count: "exact", head: true })
    .eq("review_status", "new");
  if (error) throw error;
  return count || 0;
}

export async function setFeedbackReviewStatus(feedbackId, reviewStatus, client = supabase) {
  if (!REVIEW_STATUSES.has(reviewStatus)) {
    throw new Error("Feedback status must be new or resolved.");
  }
  const { data, error } = await client
    .from("feedback")
    .update({ review_status: reviewStatus })
    .eq("feedback_id", feedbackId)
    .select("feedback_id, review_status, resolved_at, resolved_by")
    .single();
  if (error) throw error;
  return data;
}

/** Short-lived read link for one private feedback photo. Not a public URL. */
export const FEEDBACK_ATTACHMENT_SIGNED_SECONDS = 10 * 60;

export async function signFeedbackAttachments(paths, client = supabase) {
  const unique = [...new Set((paths || []).filter(Boolean))];
  if (!unique.length) return {};
  try {
    const { data, error } = await client.storage
      .from(FEEDBACK_BUCKET)
      .createSignedUrls(unique, FEEDBACK_ATTACHMENT_SIGNED_SECONDS);
    if (error) return {};
    const byPath = {};
    (data || []).forEach((item) => {
      if (item?.path && item?.signedUrl && !item.error) {
        byPath[item.path] = item.signedUrl;
      }
    });
    return byPath;
  } catch {
    return {};
  }
}
